import React, {FC, PropsWithChildren, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {StartGuideProgressBar} from '../startGuide/startGuideProgressBar';

/*
 * Props.
 */

interface OnboardingGuideProps {
  title: ReactNode;
  className?: string;
  numCompletedTasks: number;
  numTotalTasks: number;
  hasCompletedAllTasks: boolean;
  isCompact: boolean;
}

const StyledOnboardingGuideDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  flex-wrap: wrap;
`;

const StyledHeaderDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  width: 100%;
`;

const StyledTitleSpan = styled.span`
  font-size: ${fontSizes.veryLarge};
  font-weight: ${fontWeights.bold};
  color: ${(p) => p.theme.greys.shade90};
  line-height: 21px;
`;

const StyledTasksDiv = styled.div<{$isCompact: boolean}>`
  display: flex;
  flex-direction: column;
  gap: ${(p) => (p.$isCompact ? '8px' : '12px')};
  width: 100%;
  margin-top: ${(p) => (p.$isCompact ? '16px' : '20px')};
`;

/*
 * Component.
 */

export const OnboardingGuide: FC<PropsWithChildren<OnboardingGuideProps>> = (props) => {
  const {children, numCompletedTasks, numTotalTasks, hasCompletedAllTasks} = props;
  return (
    <StyledOnboardingGuideDiv className={props.className}>
      <StyledHeaderDiv>
        <StyledTitleSpan>{props.title}</StyledTitleSpan>
      </StyledHeaderDiv>

      <StartGuideProgressBar
        completedSteps={numCompletedTasks}
        totalSteps={numTotalTasks}
        hasCompletedAllTasks={hasCompletedAllTasks}
      />

      <StyledTasksDiv $isCompact={props.isCompact}>{children}</StyledTasksDiv>
    </StyledOnboardingGuideDiv>
  );
};
